import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PipelineStatusCheckboxService, PipelineStatuses } from './pipeline-status-checkbox.service';

@Component({
  selector: 'sales-ui-pipeline-status-checkbox',
  templateUrl: './pipeline-status-checkbox.component.html',
  styleUrls: [],
  standalone: false,
})
export class PipelineStatusCheckboxComponent {
  statuses: UntypedFormGroup = new UntypedFormGroup({
    open: new UntypedFormControl(),
    won: new UntypedFormControl(),
    lost: new UntypedFormControl(),
  });

  constructor(
    public dialogRef: MatDialogRef<PipelineStatusCheckboxComponent>,
    private readonly store: PipelineStatusCheckboxService,
  ) {
    this.store.getValueToInitForm().then((values: PipelineStatuses) => {
      const storeHasPreviousValue = !!values;
      const formUntouched = this.statuses.pristine;
      if (formUntouched && storeHasPreviousValue) {
        this.statuses.setValue({
          open: values.open,
          won: values.won,
          lost: values.lost,
        });
      }
    });
  }

  save(fg: UntypedFormGroup): void {
    this.store.storeStatuses({
      open: fg.value['open'],
      won: fg.value['won'],
      lost: fg.value['lost'],
    });
    this.dialogRef.close();
  }
}
